import { api, unwrap } from './http';

export default {
  list: async (params = {}) => unwrap(api.get('/Tasks', params)),

  getById: async (id) => unwrap(api.get(`/Tasks/${id}`)),

  create: async (payload) => unwrap(api.post('/Tasks', payload)),

  update: async (id, payload) => unwrap(api.put(`/Tasks/${id}`, payload)),

  remove: async (id) => unwrap(api.delete(`/Tasks/${id}`)),

  updateStatus: async (id, statusCode) => unwrap(
    api.put(`/Tasks/UpdateStatus?id=${encodeURIComponent(id)}&StatusCode=${encodeURIComponent(statusCode)}`),
  ),

  getPendingCount: async (params = {}) => unwrap(api.get('/Tasks/Pending/Count', params)),
};
